import Component from './message_history.vue'
export default Component
